import React from "react";
import StarIcon from "src/icons/StarIcon";

interface MarketTableErrorProps {
  reduxState: any;
}

const MarketTableError = (props: MarketTableErrorProps) => {
  const { reduxState } = props;
  return (
    <>
      {reduxState.type === "watchlist" && (
        <h3
          style={{
            position: "absolute",
            top: "40%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            textAlign: "center",
          }}
        >
          Your watchlist looks quite empty, doesn't it? Add coins to your watchlist by tapping the{" "}
          <StarIcon /> icon
        </h3>
      )}
      {reduxState.type === "portfolio" && (
        <h3
          style={{
            position: "absolute",
            top: "40%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            textAlign: "center",
          }}
        >
          It looks like you don't have any holdings with us, contact your broker to get started!
        </h3>
      )}
    </>
  );
};

export default MarketTableError;
